module.exports = __webpack_public_path__ + "static/media/travisgo_mobile_bg_businesspartner@1x.8b7bf20a.jpg";